<app-dialog
	titleButton="Salvar"
	secTitleButton="Cancelar"
	[modalTitle]="isEdit ? 'Editar dependente' : 'Incluir dependente'"
	[secButton]="true"
	[hideFooter]="false"
	[noMargins]="true"
	[disabled]="form.invalid"
	(dialogClose)="closeModal()"
	(dialogSave)="onContinue()"
>
	<ng-container *ngIf="isLoading">
		<div class="d-f jc-c ai-c w-100 mt-giant">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	</ng-container>
	<ng-container *ngIf="!isLoading">
		<div class="w-100 h-100 mb-fix container" [formGroup]="form">
			<div class="d-f mt-xxxs ml-xxxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="CPF do titular"
					appearance="outline"
				>
					<mat-label>CPF do titular</mat-label>
					<input
						type="text"
						matInput
						mask="000.000.000-00"
						placeholder="CPF do titular"
						formControlName="cpf_titular"
						id="sct-{{ inputId }}"
						(blur)="onCpfTitularBlur()"
					/>
					<mat-error
						*ngIf="
							form.get('cpf_titular')?.hasError('pattern') &&
							!form.get('cpf_titular')?.hasError('required') &&
							!form.get('cpf_titular')?.hasError('minlength')
						"
					>
						Digite um CPF válido
					</mat-error>
					<mat-error
						*ngIf="
							form.get('cpf_titular')?.hasError('minlength') &&
							!form.get('cpf_titular')?.hasError('pattern') &&
							!form.get('cpf_titular')?.hasError('required')
						"
					>
						CPF do titular não encontrado
					</mat-error>
					<mat-error *ngIf="form.get('cpf_titular')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1"
					title="CPF do dependente"
					appearance="outline"
				>
					<mat-label>CPF do dependente</mat-label>
					<input
						type="text"
						matInput
						mask="000.000.000-00"
						placeholder="CPF do dependente"
						formControlName="cpf"
						id="scd-{{ inputId }}"
						(blur)="onCpfDependentBlur()"
					/>
					<mat-error
						*ngIf="
							form.get('cpf')?.hasError('pattern') &&
							!form.get('cpf')?.hasError('required') &&
							!form.get('cpf')?.hasError('minlength')
						"
					>
						Digite um CPF válido
					</mat-error>
					<mat-error
						*ngIf="
							form.get('cpf')?.hasError('minlength') &&
							!form.get('cpf')?.hasError('pattern') &&
							!form.get('cpf')?.hasError('required')
						"
					>
						CPF do dependente já cadastrado
					</mat-error>
					<mat-error *ngIf="form.get('cpf')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f ml-xxxs mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Nome completo"
					appearance="outline"
				>
					<mat-label>Nome completo</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome completo"
						formControlName="name"
						id="snc-{{ inputId }}"
					/>
					<mat-error *ngIf="form.get('name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1"
					title="Email"
					appearance="outline"
				>
					<mat-label>Email</mat-label>
					<input
						type="text"
						matInput
						placeholder="Email"
						formControlName="email"
						id="sed-{{ inputId }}"
						(blur)="onEmailBlur()"
					/>
					<mat-error
						*ngIf="
							form.get('email')?.hasError('email') &&
							!form.get('email')?.hasError('required')
						"
					>
						Digite um email válido
					</mat-error>
					<mat-error
						*ngIf="
							form.get('email')?.hasError('minlength') &&
							!form.get('email')?.hasError('email') &&
							!form.get('email')?.hasError('required')
						"
					>
						Email já cadastrado
					</mat-error>
					<mat-error *ngIf="form.get('email')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f ml-xxxs mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Tipo de dependente"
					appearance="outline"
				>
					<mat-label>Tipo de dependente</mat-label>
					<mat-select
						formControlName="type"
						(selectionChange)="checkDependentType()"
					>
						<mat-option
							*ngFor="let depType of dependentTypes"
							[value]="depType.value"
						>
							{{ depType.label }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.get('type')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1"
					title="Data de casamento"
					appearance="outline"
				>
					<mat-label>Data de Casamento</mat-label>
					<input
						matInput
						placeholder="Data de casamento"
						formControlName="marriageDate"
						id="sbd-{{ inputId }}"
						[matDatepicker]="pickerc"
					/>
					<mat-datepicker-toggle matSuffix [for]="pickerc">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerc></mat-datepicker>
					<mat-error *ngIf="form.get('marriageDate')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f ml-xxxs mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-1"
					title="Telefone"
					appearance="outline"
				>
					<mat-label>Telefone</mat-label>
					<input
						type="text"
						matInput
						placeholder="Telefone"
						formControlName="phone"
						id="sdt-{{ inputId }}"
						mask="{{ phoneMask(form.get('phone')?.value) }}"
					/>
					<mat-error
						*ngIf="
							form.get('phone')?.hasError('pattern') &&
							!form.get('phone')?.hasError('required')
						"
					>
						Digite um telefone válido
					</mat-error>
					<mat-error *ngIf="form.get('phone')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1"
					title="Data de nascimento"
					appearance="outline"
				>
					<mat-label>Data de nascimento</mat-label>
					<input
						matInput
						placeholder="Data de nascimento"
						formControlName="birthday"
						id="sbd-{{ inputId }}"
						[matDatepicker]="picker"
					/>
					<mat-datepicker-toggle matSuffix [for]="picker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
					<mat-error *ngIf="form.get('birthday')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f ml-xxxs mt-xxs line">
				<mat-form-field
					class="mr-xxxs col-2"
					title="Nome da mãe"
					appearance="outline"
				>
					<mat-label>Nome da mãe</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome da mãe"
						formControlName="mothers_name"
						id="smn-{{ inputId }}"
					/>
					<mat-error *ngIf="form.get('mothers_name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mb-nano ml-xxxs mt-xxs line">
				<mat-form-field class="mr-xxxs col-1" title="Sexo" appearance="outline">
					<mat-label>Sexo</mat-label>
					<mat-select formControlName="gender">
						<mat-option *ngFor="let gender of genders" [value]="gender">
							{{ capitalize(gender) }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="form.get('gender')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1"
					title="Data de inclusão"
					appearance="outline"
				>
					<mat-label>Data de inclusão</mat-label>
					<input
						matInput
						placeholder="Data de inclusão"
						formControlName="inclusion_day"
						id="sid-{{ inputId }}"
						[matDatepicker]="pickerb"
					/>
					<mat-datepicker-toggle matSuffix [for]="pickerb">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #pickerb></mat-datepicker>
					<mat-error *ngIf="form.get('inclusion_day')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</ng-container>
</app-dialog>
